import { Navigate, Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { BillingAccessLayout } from 'pages/settings/pages/billing/layout/BillingAccessLayout'
import { BillingPageLayout } from 'pages/settings/pages/billing/layout/BillingPageLayout'
import { OverviewPageLayout } from 'pages/settings/pages/billing/layout/OverviewPageLayout/OverviewPageLayout'
import { ViewPageLayout } from 'pages/settings/pages/billing/layout/ViewPageLayout/ViewPageLayout'
import { UpgradeRouter } from 'pages/settings/pages/billing/pages/upgrade'
import { OverviewRouter } from 'pages/settings/pages/billing/pages/overview/route/overviewRouter'
import { BillingRoutes } from './type'

export const BillingRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<BillingAccessLayout />}>
        <Route element={<BillingPageLayout />}>
          <Route element={<OverviewPageLayout />}>
            <Route index element={<Navigate to={`${BillingRoutes.overview}`} replace />} />
            <Route path={`${BillingRoutes.overview}`} element={<OverviewRouter />} />
          </Route>
          <Route element={<ViewPageLayout />}>
            <Route
              path={`${BillingRoutes.overview}/${BillingRoutes.upgrade}`}
              element={<UpgradeRouter />}
            />
          </Route>
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
})
